import { combineReducers } from "redux";
import catalogueReducer from "./catalogue/reducer";
import assumptionsReducer from "./assumptions/reducer";
import configurationsReducer from "./configurations/reducer";
import measurementsReducer from "./measurements/reducer";
import glossaryReducer from "./glossary/reducer";
import persistenceReducer from "./persistence/reducer";
import uiReducer from "./ui/reducer";

const coilConfiguratorReducer = combineReducers({
  catalogue: catalogueReducer,
  assumptions: assumptionsReducer,
  configurations: configurationsReducer,
  measurements: measurementsReducer,
  glossary: glossaryReducer,
  persistence: persistenceReducer,
  ui: uiReducer,
});

export type CoilConfiguratorState = ReturnType<typeof coilConfiguratorReducer>;
export default coilConfiguratorReducer;
